import Api from '@/api/Api'

export default [
  {
    path: '/',
    name: 'home',
    redirect: 'workspaces'
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@views/login')
  },
  {
    path: '/workspaces',
    name: 'workspaces',
    meta: {
      authRequired: true
    },
    component: () => lazyLoadView(import('@views/workspace'))
  },
  {
    path: '/workspaces/:id',
    name: 'workspace-details',
    meta: {
      authRequired: true
    },
    beforeEnter: (to, from, next) => {
      const { id } = to.params
      Api.getOpenWorkspace({ workspaceId: id })
      next()
    },
    component: () => lazyLoadView(import('@views/new-workspace')),
    children: [{
      path: '',
      name: 'wks',
      component: () => lazyLoadView(import('@views/workspace-details'))
    }, {
      path: 'mosaic',
      name: 'mosaic',
      component: () => lazyLoadView(import('@components/workspaces/workspace/ard-toolkit/mosaic/mosaic'))
    }]
  },
  {
    path: '/image-share/:id',
    name: 'Image-share',
    component: () => lazyLoadView(import('@views/image-share')),
    meta: {
    }
  },
  {
    path: '/map-share/:id',
    name: 'Maps-share',
    component: () => lazyLoadView(import('@views/image-share')),
    meta: {
    }
  },
  {
    path: '/activity/:id',
    name: 'Activity log',
    component: () => lazyLoadView(import('@views/activity')),
    meta: {
      authRequired: true
    }
  },
  {
    path: '/error',
    name: 'error',
    component: () => lazyLoadView(import('@views/user-deactive'))
  },
  {
    path: '/404',
    name: '404',
    beforeEnter(to, from, next) {
      // Put the full page url including the protocol http(s) below
      window.location = 'https://app.terravelox.id'
      
    },
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true
  },
  {
    path: '/401',
    name: '401',
    component: () => lazyLoadView(import('@views/_401'))
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    component: () => lazyLoadView(import('@views/_404'))
    // redirect: '404'
  }
]

function lazyLoadView(AsyncView) {
  // uncomment this line to debug
  // return AsyncView
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@views/_loading').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 200,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    error: require('@views/_timeout').default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 120000
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    }
  }).catch(er => {
    console.log(er)
  })
}



// WEBPACK FOOTER //
// ./src/router/routes.js